const locales = {nl: 'nl-NL', en: 'en-GB', fr: 'fr-FR', es: 'es-ES'};
const number = String.raw`\d+(?:[.,\u00a0\u202f]\d+| \d{3})*`;
const euro = new RegExp(String.raw`€[\t \u00a0\u202f]*(${number})|(${number})[\t \u00a0\u202f]*€`, 'g');
const formatters = new Map();

export function formatEuroText(text, language) {
  const locale = locales[language.toLowerCase().split('-')[0]];
  if (!locale || !text.includes('€')) return text;
  return text.replace(euro, (original, before, after) => {
    const raw = (before || after).replace(/[ \u00a0\u202f]/g, '');
    const decimal = raw.match(/[.,](\d{1,2})$/);
    const digits = decimal ? decimal[1].length : 0;
    const integer = decimal ? raw.slice(0, decimal.index) : raw;
    const value = Number(integer.replace(/[.,]/g, '') + (decimal ? '.' + decimal[1] : ''));
    if (!Number.isFinite(value)) return original;
    const key = locale + digits;
    if (!formatters.has(key)) formatters.set(key, new Intl.NumberFormat(locale, {
      style: 'currency', currency: 'EUR', minimumFractionDigits: digits, maximumFractionDigits: digits,
    }));
    return formatters.get(key).format(value);
  });
}

if (typeof document !== 'undefined') {
  const excluded = 'script,style,noscript,textarea,input,select,option,pre,code,svg,[contenteditable],iframe,[data-tg-currency-ignore]';
  const language = document.documentElement.lang;
  function update(root) {
    if (!root.isConnected) return;
    const parent = root.nodeType === Node.TEXT_NODE ? root.parentElement : root;
    if (!parent || parent.closest(excluded)) return;
    if (root.nodeType === Node.TEXT_NODE) {
      const formatted = formatEuroText(root.nodeValue, language);
      if (formatted !== root.nodeValue) root.nodeValue = formatted;
      return;
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement.closest(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT,
    });
    let node;
    while ((node = walker.nextNode())) update(node);
  }
  update(document.body);
  const observer = new MutationObserver(records => {
    const roots = new Set();
    for (const record of records) {
      if (record.type === 'characterData') roots.add(record.target);
      else record.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) roots.add(node);
      });
    }
    roots.forEach(update);
  });
  observer.observe(document.body, {subtree: true, childList: true, characterData: true});
}
